import React, { PureComponent } from 'react';
//import PropTypes from 'prop-types';
import {
    Form, Input, Button,
    message,
    InputNumber,
    Select,
    Row,
    Col
} from 'antd';

import { postRequest, request } from '../service';
import { urlChangeSetting, urlGetSetting } from '../../config';
import './SglobalForm.css';

const Option = Select.Option;

class SglobalForm extends PureComponent {

    state = {
        header: "RS MELATI HUSADA",
        subheader: "SUB HEADER SAYA INI",
        slide: {
            tt: {
                max_records_per_slide: 5,
                type: 1
            },
            jd: {
                max_records_per_slide: 10,
                type: 1
            }
        },
        loading: false
    }

    componentDidMount = () => {
        this.setState({
            loading: true
        })
        this.getConfig();
    }

    getConfig = async () => {
        let config = await request(urlGetSetting);
        if (config.status !== 'error') {
            config.loading = false;
            this.setState(config);
            message.info("Load setting dari server berhasil.");
        } else {
            this.setState({
                loading: false
            });
            message.error("Load setting dari server gagal. Cek Komunikasi server!");
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({
                    loading: true
                })
                let param = Object.assign({}, this.state);
                param.header = values.header;
                param.subheader = values.subheader;
                param.slide.tt.max_records_per_slide = values.max_records_per_slide_tt;
                param.slide.tt.type = values.type_tt;

                delete param.loading;

                this.postConfig(param);
            }
        });
    }

    postConfig = async (param) => {
        let response = await postRequest(urlChangeSetting, param);

        if (response.status) {
            message.success("Setting Tersimpan.");
        } else {
            message.error("Koneksi server error.");
        }

        let new_config = response.new_config;
        new_config.loading = false;
        this.setState(new_config);
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
            style: {
                marginBottom: 0
            }
        };
        const formSubItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
            style: {
                marginBottom: 0
            }
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };
        return (
            <div>
                <Form onSubmit={this.handleSubmit} hideRequiredMark layout="horizontal" >
                    <Form.Item {...formItemLayout} label="Nama Rumah Sakit">
                        {getFieldDecorator('header', {
                            rules: [{
                                required: true, message: 'Nama Rumah Sakit Tidak Boleh Kosong!',
                            }],
                            initialValue: this.state.header
                        })(
                            <Input />
                        )}
                    </Form.Item>
                    <Form.Item {...formItemLayout} label="Alamat Rumah Sakit">
                        {getFieldDecorator('subheader', {
                            rules: [{
                                required: true, message: 'Alamat Rumah Sakit Tidak Boleh Kosong!',
                            }],
                            initialValue: this.state.subheader
                        })(
                            <Input />
                        )}
                    </Form.Item>
                    <Form.Item label="Informasi TT" style={{
                        marginBottom: 0
                    }}>
                        <Row>
                            <Col span={24}>
                                <Form.Item {...formSubItemLayout} label="Baris Per-Slide">
                                    {getFieldDecorator('max_records_per_slide_tt', {
                                        rules: [{
                                            required: true, message: 'Max Records Per Slide Tidak Boleh Kosong!',
                                        }],
                                        initialValue: this.state.slide.tt.max_records_per_slide
                                    })(
                                        <InputNumber style={{width: "100%"}}/>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                        <Col span={24}>
                                <Form.Item {...formSubItemLayout} label="Tipe">
                                    {getFieldDecorator('type_tt', {
                                        rules: [{
                                            required: true, message: 'Tipe Tidak Boleh Kosong!',
                                        }],
                                        initialValue: this.state.slide.tt.type
                                    })(
                                        <Select>
                                            <Option value={1}>1</Option>
                                            <Option value={2}>2</Option>
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item {...tailFormItemLayout}>
                        <Button loading={this.state.loading} type="primary" htmlType="submit">Terapkan</Button>
                    </Form.Item>
                </Form>
            </div >
        );
    }
}

const WrappedSglobalForm = Form.create({ name: 'SglobalForm' })(SglobalForm);

SglobalForm.propTypes = {

};

export default WrappedSglobalForm;